export function CheckIcon({ size }: { size?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "20"}
      height={size ? size : "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4 11L6.55556 13.7778L12.3333 8"
        stroke="inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function getCheckColor(props: {
  isSelected: boolean;
  isDarkTheme: boolean;
}) {
  if (props.isSelected) {
    if (props.isDarkTheme) {
      return "stroke-white";
    }
    return "stroke-basePrimaryDark darkTheme:stroke-white";
  } else {
    if (props.isDarkTheme) {
      return "stroke-[#7C7C7C]";
    }
    return "darkTheme:stroke-[#7C7C7C] stroke-[#ABABAB]";
  }
}
